export default __webpack_public_path__ + "static/media/sold.e012c598.png";